import { X } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface DrawerProps {
  open: boolean
  onClose: () => void
  title?: ReactNode
  subtitle?: ReactNode
  width?: number
  children: ReactNode
}

export function Drawer({ open, onClose, title, subtitle, width = 720, children }: DrawerProps) {
  if (!open) return null
  return (
    <div className="fixed inset-0 z-50">
      {/* Backdrop */}
      <div
        onClick={onClose}
        className="absolute inset-0 bg-navy-900/40 backdrop-blur-sm animate-in fade-in"
      />

      {/* Panel */}
      <div
        className="absolute top-0 right-0 bottom-0 bg-white shadow-2xl overflow-y-auto animate-in slide-in-from-right"
        style={{ width }}
      >
        {(title || subtitle) && (
          <div className="sticky top-0 bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between z-10">
            <div>
              {subtitle && (
                <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">
                  {subtitle}
                </div>
              )}
              {title && (
                <h2 className="font-display text-2xl font-semibold text-navy-700">{title}</h2>
              )}
            </div>
            <button
              onClick={onClose}
              className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-slate-100 transition"
            >
              <X className="w-5 h-5 text-slate-500" />
            </button>
          </div>
        )}
        {children}
      </div>

      <style>{`
        @keyframes slide-in-from-right {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-in { animation-duration: 0.25s; animation-fill-mode: both; }
        .slide-in-from-right { animation-name: slide-in-from-right; }
        .fade-in { animation-name: fade-in; }
      `}</style>
    </div>
  )
}
